import { useMemo } from 'react';
import { useNovelRepository } from '@/hooks/useNovelRepository';
import { ContentSummary } from '@/lib/types';
import { toTimestamp } from '@/lib/date-utils';

/**
 * Hook to fetch and manage the list of text summaries for the sidebar.
 * Lightweight: Does not fetch full prose documents.
 */
export function useTextList() {
  const { novel } = useNovelRepository();

  const textSummaries = useMemo((): ContentSummary[] => {
    // Both entities/narrative summaries live under novel.summaries for the UI context
    const contents = novel.summaries.contents;
    return Object.values(contents)
      .sort((a, b) => {
        const timeA = toTimestamp(a.updatedAt);
        const timeB = toTimestamp(b.updatedAt);
        return timeB - timeA || a.name.localeCompare(b.name);
      });
  }, [novel.summaries]);

  const isLoadingTexts = !novel.id;

  return {
    textSummaries,
    isLoadingTexts,
  };
}
